import React from 'react'
import SVG from 'react-inlinesvg'
import { Button } from '@bhvr/web-design-system'

import chevron from '../../../assets/icons/chevron.svg'
import StoreLink from './store-link'


const StoreCategories = (props) => {
  if (!props.data || props.data === null) {
    return ''
  }
  const stores = props.data
  const strings = props.strings

  const linksPC = stores.map((store, i) => (
    store.platformType === 'pc' && (
      <StoreLink
        key={i}
        index={i}
        pageContext={props.pageContext}
        layout="list"
        data={store}
        eventData={props.eventData}
        logoSize="small"
        className={`${props.storeClassName ? props.storeClassName : ''}`}
      />
    )
  ))
  const linksConsole = stores.map((store, i) => (
    store.platformType === 'console' && (
      <StoreLink
        key={i}
        index={i}
        pageContext={props.pageContext}
        layout="list"
        data={store}
        eventData={props.eventData}
        logoSize="small"
        className={`${props.storeClassName ? props.storeClassName : ''}`}
      />
    )
  ))

  const havePC = stores.some(el => el.platformType === 'pc')
  const haveConsole = stores.some(el => el.platformType === 'console')

  // Open/Close the Platform Selector
  function openSelector(platform) {
    const modalPreview = document.querySelector('.modal-preview')
    const platformsSlide = document.getElementById('buyGamePlatforms')
    const currentPlatform = document.querySelector('#buyGamePlatforms ul[data-content="' + platform + '"]')
    modalPreview.classList.add('blurred')
    platformsSlide.classList.remove('hidden')
    currentPlatform.classList.remove('hidden')
  }
  const closeSelector = e => {
    const modalPreview = document.querySelector('.modal-preview')
    const platformsSlide = document.getElementById('buyGamePlatforms')
    const currentPlatform = document.querySelectorAll('#buyGamePlatforms ul[data-content]')
    modalPreview.classList.remove('blurred')
    platformsSlide.classList.add('hidden')
    currentPlatform.forEach(slide => {
      slide.classList.add('hidden')
    })
  }

  return (
    <div className="modal-buy-categories relative w-full">
      {havePC && haveConsole && (
        <div className="h-full w-full">
          {havePC && linksPC && (
            <button
              className="modal-buy-selection relative flex w-full items-center justify-between px-16 py-8 transition-all duration-300"
              onClick={() => openSelector('pc')}
              type="button"
            >
              <span className="block w-full text-left">
                <span className="block w-full text-left">
                  {strings && strings.platforms ? strings.platforms.pc : 'PC'}
                </span>
              </span>
              <span className="chevron pointer-events-none">
                <SVG
                  onError={error => console.log(error.message)}
                  cacheRequests={true}
                  preProcessor={code =>
                    code.replace(/fill=".*?"/g, 'fill="currentColor"')
                  }
                  src={chevron}
                  className="-rotate-90"
                />
              </span>
            </button>
          )}
          {haveConsole && linksConsole && (
            <button
              className="modal-buy-selection relative flex w-full items-center justify-between px-16 py-8 transition-all duration-300"
              onClick={() => openSelector('console')}
              type="button"
            >
              <span className="block w-full text-left">
                {strings && strings.platforms ? strings.platforms.console : 'Console'}
              </span>
              <span className="chevron pointer-events-none">
                <SVG
                  onError={error => console.log(error.message)}
                  cacheRequests={true}
                  preProcessor={code =>
                    code.replace(/fill=".*?"/g, 'fill="currentColor"')
                  }
                  src={chevron}
                  className="-rotate-90"
                />
              </span>
            </button>
          )}
        </div>
      )}
      <div
        id="buyGamePlatforms"
        className={`absolute top-0 left-0 h-full w-full bg-tertiary ${(havePC && haveConsole) && 'hidden'}`}
      >
        {havePC && haveConsole && (
          <Button
            className="store-link-back cursor-pointer flex items-center justify-between mb-10 py-4 pl-4 pr-11"
            onClick={closeSelector}
          >
            <span className="chevron mr-2">
              <SVG
                onError={error => console.log(error.message)}
                cacheRequests={true}
                preProcessor={code =>
                  code.replace(/fill=".*?"/g, 'fill="currentColor"')
                }
                src={chevron}
                className="rotate-90"
              />
            </span>
            <span className="text-white">{strings && strings.actions ? strings.actions.back : 'Back'}</span>
          </Button>
        )}
        {havePC && linksPC && (
          <ul data-content="pc" className={`store-link-list ${(havePC && haveConsole) && 'hidden'}`}>
            {linksPC}
          </ul>
        )}
        {haveConsole && linksConsole && (
          <ul data-content="console" className={`store-link-list ${(havePC && haveConsole) && 'hidden'}`}>
            {linksConsole}
          </ul>
        )}
      </div>
    </div>
  )
}

export default StoreCategories